import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import TicketService from 'services/ticketService';
import AdminLayout from 'layouts/AdminLayout';

export default function AdminTicketPage() {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);

  function handleTicketClick(ticket_id) {
    return () => {
      navigate(`/admin/tickets/${ticket_id}`);
    };
  }

  useEffect(() => {
    TicketService.getTickets().then((data) => {
      setTickets(data);
    });
  }, []);

  return (
    <AdminLayout>
      <div
        className="
        flex items-center w-full 
        mx-auto mt-4 p-4 px-4
        select-none space-x-4"
      >
        <div
          className="
          flex-shrink-0 
          p-2
          cursor-pointer 
          rounded-full
          hover:bg-[#272727] hover:scale-[1.1] transition-all duration-300
          "
          onClick={() => navigate(-1)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-left"
          >
            <path d="M9 14 4 9l5-5" />
            <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11" />
          </svg>
        </div>
        <div className="flex-1 text-white font-semibold text-2xl"> Tickets List</div>
      </div>
      <div
        className="
          m-3
          rounded-2xl
          h-[70vh]
          border-[0.5px] border-[#33363A]
          overflow-y-scroll scrollbar-thin
          text-gray-100
        "
      >
        {tickets.map((ticket) => (
          <>
            <div
              key={ticket.id}
              className="
              flex flex-row justify-between items-center 
              p-4 m-2
              rounded-2xl
              cursor-pointer hover:bg-[#1a1a1a60] transition-all duration-300
              "
              onClick={handleTicketClick(ticket.id)}
            >
              <div className="flex items-center mb-4 md:mb-0">
                <div className="flex items-center gap-4">
                  {(() => {
                    return (
                      <>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          class="lucide lucide-tag"
                        >
                          <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
                          <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
                        </svg>
                        <p className="font-bold">Subject : {ticket.subject}</p>
                      </>
                    );
                  })()}
                </div>
              </div>
              <div className="flex flex-col items-start md:items-end text-sm">
                <p>Created At: {new Date(ticket.created_at).toLocaleDateString()}</p>
              </div>
            </div>
          </>
        ))}
      </div>
    </AdminLayout>
  );
}
